import { css } from '@emotion/css';
import { LabelOnLeftWrap, noteStyle } from 'Shared/forms/Wrap'
import type {VisualWithInfoLayout} from 'Shared/model/Components';
import { IntegratedSelectorAndComponent } from 'Shared/backend/widgets/IntegratedSelectorAndComponent';
import { SingleSelect } from 'Shared/forms/Inputs';
import { optionList } from 'Shared/backend/widgets/ComponentOptions';
import { Show, createSignal } from 'solid-js';
import { useLayout } from 'Shared/backend/LayoutProvider';
import { initImage } from 'Shared/backend/widgets/CreationUtils';


export function initVisualWithInfo()
{
	return {layout:'visualWithInfo',visual:initImage(),upper:{layout:'text'},lower:{layout:'text',type:'plain'}};
}

export const detailsStyle = () => css({
	display: 'flex',
	flexDirection: 'column',
	gap: '0.8em',
});


export function VisualWithInfo(P:VisualWithInfoLayout)
{
	const lo = useLayout();

	const visualOptions = optionList(['image','slides','embed','posters','overlay','styles'],['popup']);

	const infoOptions = optionList(['text','vertical','buttons'],['popup']);

// XXX wideTextAlign and narrowTextAlign are candidates for inclusion as settings here. Currently they are in the theme. Note they are/can be inherited by child components.

	const [showUpper,setShowUpper] = createSignal(true);
	const [showLower,setShowLower] = createSignal(true);
	const [showVisual,setShowVisual] = createSignal(true);

	return (
		<div class={detailsStyle()}>
			<Show when={lo.layout()}>
				<div class={noteStyle()}>
					<p>
						On desktop screens this component displays a visual block (e.g. an image or slider) on one side 
						and text on the other side, with the text wrapping underneith if necessary.
					</p>
					<p>
						On mobiles the text is positioned above and beneith the visual.
					</p>
				</div> 

				<LabelOnLeftWrap label='Position of the visual block'>
					<SingleSelect field='visualPosition' required={true} initialValue='left' options={{
						left: 'Left',
						right: 'Right',
					}}/>
				</LabelOnLeftWrap>

				<div class={noteStyle()}>
					The upper info will appear above the visual on mobiles, and to the side on desktops.
					The lower info will appear below the visual on mobiles, and to the side on desktops. It may wrap under the visual.
				</div>
			</Show>

			<IntegratedSelectorAndComponent {...P.upper} label='Upper info' contentFieldName='upper' options={infoOptions} 
				expanded={showUpper} setExpanded={setShowUpper}
			/>

			<IntegratedSelectorAndComponent {...P.visual} label='Visual' contentFieldName='visual' options={visualOptions} required 
				expanded={showVisual} setExpanded={setShowVisual}
			/>

			<IntegratedSelectorAndComponent {...P.lower} label='Lower info' contentFieldName='lower' options={infoOptions} 
				expanded={showLower} setExpanded={setShowLower}
			/>
		</div>
	);
}

